import React from 'react'
import autobind from 'autobind-decorator'
import persianJs from 'persianjs'

import PureComponent from '../PureComponent'

class NumberInput extends PureComponent {
  /**
   * Notify changes to parent
   * @param {any} changedValue changed value
   */
  triggerChange(changedValue) {
    // Should provide an event to pass value to Form.
    const onChange = this.props.onChange
    if (onChange) {
      onChange(changedValue)
    }
  }

  /**
   * Normalize value
   * @param {*} value price value
   * @return {String} formatted price
   */
  parseValue(value) {
    if (!value) return ''

    return persianJs(value.toString())
      .toEnglishNumber()
      .toString()
  }

  /**
   * Handle input change
   * @param {*} value
   */
  handleInputChange(value) {
    this.triggerChange(value)
  }


  /** @inheritdoc */
  render() {
    const { ...rest } = this.props

    return (
      <input
        type="number"
        {...rest}
        style={{width: '100%'}}
        pattern="\d*"
        parser={this.parseValue}
        onChange={this.handleInputChange}
      />
    )
  }
}

export default autobind(NumberInput)
